import Head from "next/head";
import React from "react";
import ContactUs from "../components/homepage/ContactUs";
import Footer from "../components/homepage/Footer";
import Header from "../components/homepage/Header";
import QuestionsAndAnswers from "../components/upgrade/QandA";
import UpgradePlan from "../components/upgrade/UpgradePlan";
import { plans } from "../configs/upgrade-plans";
import SectionBg from "../public/images/bg-center.png";

const Upgrade = () => {
  return (
    <div id="upgrade-page">
      <Header />
      <Head>
        <title>Upgrade</title>
        <meta name="description" content="" />
      </Head>
      <div
        className="absolute w-full h-[750px] top-0 -z-10 "
        style={{
          backgroundColor: "#fff",
          backgroundImage: `url("${SectionBg.src}")`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          height: "750",
        }}
      >
        <div className="relative boxed-container">
          <div className="mt-48 text-center">
            <div className="flex flex-col gap-1 text-6xl font-extrabold">
              <span>Upgrade, no</span>
              <span>hidden charges.</span>
            </div>
            <div className="gradient-header">Pick your plan.</div>
            <div className="mt-8 font-semibold leading-relaxed mb-28">
              No more complex Paper Work. Draw, Connect Pipes and Fittings.
              <br />
              Creating a Takeoff now is so Easy
            </div>

            <div className="flex flex-col items-center gap-10 pb-20 lg:gap-5 lg:flex-row lg:items-start">
              <div className="w-3/4 lg:w-1/3">
                <UpgradePlan plan={plans.free} />
              </div>
              <div className="w-3/4 lg:w-1/3">
                <UpgradePlan plan={plans.pro} />
              </div>
              <div className="w-3/4 lg:w-1/3">
                <UpgradePlan plan={plans.visual} />
              </div>
            </div>
          </div>
          <QuestionsAndAnswers />
          <ContactUs />
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Upgrade;
Upgrade.publicPage = true;
